import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { Reveal, SectionHead } from "./Reveal";
import { useSite } from "../lib/site";

export const Approach = () => {
  const { t } = useSite();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 75%", "end 60%"] });
  const scale = useSpring(scrollYProgress, { stiffness: 80, damping: 20 });

  return (
    <section id="approach" className="py-24 lg:py-36 bg-[var(--ink-2)] border-y border-[var(--line)]" data-testid="approach-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <SectionHead id="approach" eyebrow={t.approach.eyebrow} title={t.approach.title} />
          </div>
        </div>
        <div ref={ref} className="lg:col-span-7 relative">
          <div className="absolute top-2 bottom-2 start-[1.15rem] w-px bg-[var(--line)]" />
          <motion.div style={{ scaleY: scale }} className="absolute top-2 bottom-2 start-[1.15rem] w-px bg-[var(--gold)] origin-top" />
          <ol className="space-y-16 lg:space-y-24">
            {t.approach.steps.map((s, i) => (
              <li key={i} className="relative ps-16" data-testid={`approach-step-${i + 1}`}>
                <span className="absolute start-0 top-0 grid h-10 w-10 place-items-center rounded-full border border-[var(--gold)] bg-[var(--ink-2)] f-mono text-xs text-[var(--gold)]">0{i + 1}</span>
                <Reveal>
                  <h3 className="f-display text-3xl sm:text-5xl text-[var(--paper)]">{s.t}</h3>
                  <p className="mt-4 max-w-lg text-base sm:text-lg leading-relaxed text-[var(--muted)]">{s.d}</p>
                </Reveal>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
